import { SelectOption, SelectValue } from '@ui/types/select.type';

/**
 * Get selected options from multiple or single selected value
 *
 * @param value
 * @param options
 * @returns
 */
export function getSelectedOptionFromValue(
  value: SelectValue | SelectValue[],
  options: SelectOption[],
) {
  const results: SelectOption[] = [];

  if (Array.isArray(value)) {
    value.forEach((item) => results.push(...getSelectedOptionFromValue(item, options)));
  } else {
    options.forEach((option) => {
      if (Array.isArray(option.value)) {
        results.push(...getSelectedOptionFromValue(value, option.value));
      } else if (option.value === value) results.push(option);
    });
  }

  return results;
}

export default {};
